import axios from "axios";
import BASE_URL from "./config";
import { getCK } from "../storage";
import {Message} from "element-ui";
// 创建axios实例
const request = axios.create({
  baseURL: BASE_URL, // 所有的请求地址前缀部分
  timeout: 50000, // 请求超时时间(毫秒)
  headers: {
    //编译语言
    "Content-type": "application/json;charset=utf-8",
  },
});

// request 请求拦截器
request.interceptors.request.use(
  (config) => {
    let token = String(getCK("token"));
    // 获取请求的 URL
    const url = config.url || "";
    // 判断是否是登录页的请求
    // 假设登录页的 URL 是 '/login'，你可以根据实际情况修改
    if (url.includes("/login")) {
      // 如果请求不是登录页，添加 token
      config.headers = config.headers || {}; // 没有数据的话就设置为空设置为数据 
    } else if (url.includes('/user/auth/list') || url.includes('/supermarket') || url.includes('/builder') || url.includes('/portal') || url.includes('/community')) { 
      config.headers.token = token;
    } else {
      // 先确保登录
      config.headers["Authorization"] = token;
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// response 响应拦截器
request.interceptors.response.use(
  (response) => {
    // 对响应数据做点什么
    // if (code !== 200) {
    //     //请求失败（包括token失效，302，404...根据和后端约定好的状态码做出不同的处理）
    //     return Promise.reject(res)
    //   } else {
    //     //请求成功
    //     console.log(res, '成功----')
    //     return Promise.resolve(res.data)
    //   }
    // 响应后处理
    if (response.status === 200 && response.data.code === 200) {
      return Promise.resolve(response.data);
    } else {
      if(response.data != null){
        Message.error(response.data.msg);
      }else{
        Message.error("未知错误");
      }
      return Promise.reject(response.data); 
    }
  },
  (error) => {
    // 对响应错误做点什么
    return Promise.reject(error);
  }
);
export default request;
